import { kleinBlue61 } from '@spotify-internal/encore-foundation';
import { cssColorValue } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
export var Svg = styled.svg.withConfig({
  displayName: "Svg",
  componentId: "sc-1djipev-0"
})(["fill:", ";stroke:transparent;", ";"], function (props) {
  return props.$useBrandColor ? kleinBlue61 : cssColorValue(props.$semanticColor);
}, function (props) {
  return props.$condensed && css(["path:last-child{transform:translateX(-50px);}"]);
});